export default class EventBus {
  /**
  * Initialize a new event bus instance.
  */
  constructor() {
    this.bus = document.createElement('eventBus');
  }

  /**
  * Add an event listener.
  * window.EventBus.addEventListener('event-name', (event) => {
  *   event.detail.[data]
  * });
  */
  addEventListener(event, callback) {
    this.bus.addEventListener(event, callback);
  }

  /**
  * Remove an event listener.
  * window.EventBus.removeEventListener('event-name', (event) => {
  *   event.detail.[data]
  * });
  */
  removeEventListener(event, callback) {
    this.bus.removeEventListener(event, callback);
  }

  /**
  * Dispatch an event.
  * window.EventBus.dispatchEvent('event-name', {
  *   dataItem: 1
  * });
  */
  dispatchEvent(event, detail = {}) {
    this.bus.dispatchEvent(new CustomEvent(event, { detail }));
  }
}
